import classNames from 'classnames';
import styles from './styles.module.scss';

export enum VARIANTS {
  ORANGE = 'orange',
  PURPLE = 'purple',
  BLUE = 'blue',
  GREEN = 'green',
  PINK = 'pink',
}

export const OptionContainer = ({ emoji, text, variant, onSelect = () => {}, className = '' }) => {
  return (
    <div
      className={classNames(styles.optionContainer, styles?.[variant], className)}
      onClick={onSelect}
    >
      <p className={styles.emoji}>{emoji}</p>
      <p className={styles.optionText}>{text}</p>
    </div>
  );
};
